import ReportController from './report.controller';

export default class OrganisationGroupsReportController extends ReportController
{
	get endpoint() {
		return 'organisation-groups';
	}

	get title() {
		return 'Organisation Groups Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/organisation-groups.report.controller.js
 **/